import DescriptivetrainingformModule from './containers/descriptivetrainingformModule'

export {default as DescriptivetrainingformModuleLayout} from './components/descriptivetrainingformModuleLayout'

export default DescriptivetrainingformModule
